"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NoUserImage = void 0;
var _icons = require("@ori-ui/icons");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const NoUserImage = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NoUserImageWrapper, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.User, {
    fontSize: "inherit"
  })
});
exports.NoUserImage = NoUserImage;
var _default = exports.default = NoUserImage;
